module.exports = __webpack_public_path__ + "img/banner.7efe1141.png";